import styled from "styled-components";
import { CRIMSON_500, GRAYSCALE_200, GRAYSCALE_300, GRAYSCALE_400, GRAYSCALE_600, NEUTRAL_100 } from "../../styles/colors";
import { GIVONIC, INTER } from "../../styles/fonts";
import { JIDRCurrencyPng } from "../CurrencyIcon/CurrencyIcon";

export const CryptoPreviewBottomSheetBodyContainer = (styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 8px;
  padding-bottom: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const HeaderHandler = (styled.div`
  height: 4px;
  width: 28px;
  border-radius: 8px;
  background-color: ${GRAYSCALE_300};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const HeaderTitle = (styled.span`
  font-family: ${GIVONIC.regular};
  font-size: 16px;
  color: ${GRAYSCALE_600};
  margin: 4px 0;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const HeaderContainer = (styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  border-bottom: 1px solid ${NEUTRAL_100};
  gap: 4px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const DirectionText = (styled.span`
  font-family: ${INTER.extraLight};
  font-size: 12px;
  color: ${GRAYSCALE_600};
  margin-top: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

type AmountTextProps = {
  $isError?: boolean;
};

export const AmountText = (styled.span<AmountTextProps>`
  font-family: ${GIVONIC.bold};
  font-size: 16px;
  color: ${(props: AmountTextProps) => (props.$isError ? CRIMSON_500 : GRAYSCALE_600)};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const AssetWrapper = (styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  width: 100px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Separator = (styled.div`
  height: 1.5px;
  width: 100%;
  background-color: ${NEUTRAL_100};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

type ArrowIconProps = {
  width?: number;
  height?: number;
  fill?: string;
};

export const ArrowIcon: React.FC<ArrowIconProps> = ({
  width = 19,
  height = 11,
  fill = "#ABC8F5",
}) => (
  <svg width={width} height={height} viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.5" d="M0.0975249 5.3995C0.0975247 4.84886 0.543906 4.40248 1.09455 4.40248L15.074 4.40248L12.4547 1.78308C12.0641 1.39256 12.0641 0.759392 12.4547 0.368868C12.8452 -0.0216566 13.4783 -0.0216566 13.8689 0.368868L18.4745 4.97448C18.7092 5.20921 18.7092 5.58978 18.4745 5.82451L13.8689 10.4301C13.4783 10.8206 12.8452 10.8206 12.4547 10.4301C12.0641 10.0396 12.0641 9.40643 12.4547 9.01591L15.074 6.39652L1.09454 6.39652C0.543905 6.39652 0.0975245 5.95014 0.0975249 5.3995Z" fill={fill} />
  </svg>
);

export const AssetIcon = (styled.img`
  width: 36px;
  height: 36px;
  border-radius: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const JIDRCurrency = (styled(JIDRCurrencyPng)`
  width: 36px;
  height: 36px;
  border-radius: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const RateContainer = (styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const FieldName = (styled.span`
  font-family: ${INTER.semiBold};
  font-size: 12px;
  color: ${GRAYSCALE_400};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

type ValueProps = {
  $boldValue?: boolean;
};

export const Value = (styled.span<ValueProps>`
  font-family: ${(props: ValueProps) => (props.$boldValue ? INTER.bold : INTER.regular)};
  font-size: 14px;
  color: ${GRAYSCALE_600};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Row = (styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Wrapper = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const AmountWrapper = (styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const IconContainer = (styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: ${GRAYSCALE_200};
  border-radius: 100%;
  border: 1px solid ${GRAYSCALE_200};
  padding: 4px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const AssetInformation = (styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ErrorContainer = (styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ErrorText = (styled.span`
  font-family: ${INTER.medium};
  font-size: 12px;
  color: ${CRIMSON_500};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
